/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  var rotationViewed = new WeakSet();
  var rotationSuccessObserved = new WeakSet();

  function toCents(value) {
    return Number(value || 0);
  }

  function toMoney(cents) {
    return Math.round(toCents(cents)) / 100;
  }

  function getRotationItem(element) {
    var item = element && element.closest('[data-cart-rotation-item]');

    if (!item) {
      return null;
    }

    var originalPrice = toCents(item.dataset.originalPrice);
    var offerPrice = toCents(item.dataset.offerPrice);

    return {
      offer_id: item.dataset.offerId || '',
      source: 'cart_drawer',
      product_id: item.dataset.productId || '',
      product_title: item.dataset.productTitle || '',
      variant_id: item.dataset.variantId || '',
      color: item.dataset.color || '',
      anchor_color: item.dataset.anchorColor || '',
      discount_percent: Number(item.dataset.discountPercent || 0),
      original_price: originalPrice,
      offer_price: offerPrice,
      currency: item.dataset.currency || (window.theme && window.theme.current_iso_code) || 'USD'
    };
  }

  function pushRotationEvent(eventName, item) {
    if (!item) {
      return;
    }

    var originalValue = toMoney(item.original_price);
    var offerValue = toMoney(item.offer_price);
    var discountValue = Math.max(originalValue - offerValue, 0);
    var payload = {
      event: eventName,
      cart_rotation: item,
      ecommerce: {
        currency: item.currency,
        value: offerValue,
        items: [
          {
            item_id: item.variant_id,
            item_name: item.product_title,
            item_variant: item.color,
            item_category: 'Cart rotation upsell',
            price: offerValue,
            discount: discountValue,
            quantity: 1
          }
        ]
      }
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('bollide:' + eventName, { detail: payload }));
  }

  function observeRotationView(item) {
    if (!item || rotationViewed.has(item)) {
      return;
    }

    var fireView = function() {
      if (rotationViewed.has(item)) {
        return;
      }

      rotationViewed.add(item);
      pushRotationEvent('cart_rotation_upsell_view', getRotationItem(item));
    };

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            fireView();
            observer.disconnect();
          }
        });
      }, { threshold: 0.5 });

      observer.observe(item);
    } else {
      fireView();
    }
  }

  function observeRotationSuccess(button) {
    if (!button || rotationSuccessObserved.has(button)) {
      return;
    }

    rotationSuccessObserved.add(button);

    var observer = new MutationObserver(function() {
      if (button.classList.contains('is-success')) {
        pushRotationEvent('cart_rotation_upsell_add', getRotationItem(button));
        observer.disconnect();
      }
    });

    observer.observe(button, { attributes: true, attributeFilter: ['class'] });
  }

  function initRotationTracking(root) {
    (root || document).querySelectorAll('[data-cart-rotation-item]').forEach(function(item) {
      observeRotationView(item);
      var button = item.querySelector('[data-cart-rotation-button]');
      observeRotationSuccess(button);
    });
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-cart-rotation-button]');

    if (!button) {
      return;
    }

    pushRotationEvent('cart_rotation_upsell_click', getRotationItem(button));
    observeRotationSuccess(button);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initRotationTracking(document);
    });
  } else {
    initRotationTracking(document);
  }

  new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          initRotationTracking(node);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
